import React, { Component } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Chip,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper,
  InputAdornment,
  ToggleButtonGroup,
  ToggleButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  Alert,
  Stack,
  Autocomplete,
  Menu,
  ListItemIcon
} from '@mui/material';
import {
  TableBar,
  AttachMoney,
  Add,
  CheckCircle,
  Delete,
  PointOfSale,
  MoveUp
} from '@mui/icons-material';
import { AuthContext } from '../../context/AuthContext';
import io from 'socket.io-client';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import LockIcon from '@mui/icons-material/Lock';
import QrCodeIcon from '@mui/icons-material/QrCode';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PeopleIcon from '@mui/icons-material/People';
import { apiUrl } from '../../comp/ApiUrl';
import FrenteDeCaixaDialog from './FrenteDeCaixaDialog';
import { toast } from 'react-toastify';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import PrinterSettings from '../../comp/PrinterSettings';


import EditIcon from '@mui/icons-material/Edit';
import BadgeIcon from '@mui/icons-material/Badge';

import PersonIcon from '@mui/icons-material/Person';

import InventoryIcon from '@mui/icons-material/Inventory2Outlined';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import AddIcon from '@mui/icons-material/Add';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ReplyIcon from '@mui/icons-material/Reply';
import PrintIcon from '@mui/icons-material/Print';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import MesaDetalhesPanel from '../../comp/MesaDetalhesPanel';


class SistemaMesas extends Component {
  static contextType = AuthContext;
  constructor(props) {

    super(props);
    this.state = {
      tabAtual: 0,
      modalComandaAberto: false,
      modalPagamentoAberto: false,
      modalTrocarMesaAberto: false,
      mesaSelecionada: null,
      anchorEl: null,
      mesaDestinoId: '',
      dialogAberto: false,
      dadosCategorias: [],
      loading: false, // Controle de concorrência e requisições
      cancelar: {},
      modalSenhaAberto: false,
      // Controle Avançado de Pagamento Múltiplo / Dividido
      metodoPagamentoAtual: 'money',
      valorInseridoAtual: 0,
      pagamentosLancados: [],

      // Cadastro de Novas Mesas
      cadastroCodigo: '',
      cadastroCapacidade: '',

      itensTable: [],
      mesas: [],
      openTable: {},
      now: new Date()
    };
    this.socket = null;
    this.timer = null
  }

  componentDidMount() {
    this.socket = io(apiUrl, {
      transports: ['websocket'],
      withCredentials: true,
      auth: { type: 'desktop' },
    });

    this.socket.on('connect', () => {
      this.socket.emit('joinRestaurante');
      console.log('Painel Web conectado ao WebSocket!');
    });

    this.socket.on('mesaStatusAlterado', (dadosAtualizados) => {
      console.log(dadosAtualizados)
      //this.LoadTables();

      this.setState(prevState => ({
        mesas: prevState.mesas.map(m =>
          m.id === dadosAtualizados.mesaId ? {
            ...m,
            status: dadosAtualizados.status,
            persons: dadosAtualizados.persons ?? m.persons,
            opened_by: dadosAtualizados.opened_by ?? m.opened_by,
            total: dadosAtualizados.total,
            itens: dadosAtualizados.itens
          } : m
        ),
        mesaSelecionada: null
      }));

      if (dadosAtualizados.itens && dadosAtualizados.itens.length > 0) {
        if (this.context.user.role == "Cozinha") {
          const printSettings = JSON.parse(localStorage.getItem("printer_settings"));




          if (printSettings != null) {

            if (printSettings.connectionType == "ip") {
              this.printWithAgentCozinha(0, dadosAtualizados.itens, printSettings.ipAddress);
            } else if (printSettings.connectionType == "usb") {
              this.printWithAgentCozinha(0, dadosAtualizados.itens);
            } else {
              this.printWithBrowser(0, dadosAtualizados.itens);

            }

          } else {
            this.printWithBrowser(0, dadosAtualizados.itens);
          }
        }
      }

    });

    this.LoadTables();

    this.timer = setInterval(() => {
      this.setState({ now: new Date() });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.socket) this.socket.disconnect();
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  formatDuration = (openedByDate, currentTime) => {
    if (!openedByDate) return "00:00:00";

    const start = new Date(openedByDate).getTime();
    const now = currentTime ? currentTime.getTime() : new Date().getTime();
    const diffInSeconds = Math.max(0, Math.floor((now - start) / 1000));

    const hours = String(Math.floor(diffInSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((diffInSeconds % 3600) / 60)).padStart(2, "0");
    const seconds = String(diffInSeconds % 60).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  };

  LoadTables() {
    fetch(`${apiUrl}/tables`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("userToken"),
      },
    }).then((response) => {
      if (response.status === 200) {
        response.json().then((data) => {
          this.setState({ mesas: data });
        });
      }
    });
  }

  handleTabChange = (event, novoValor) => {
    this.setState({ tabAtual: novoValor });
  };
  handleOpenMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  // Fechar o menu
  handleCloseMenu = (item) => {
    this.setState({ anchorEl: null });
  };

  handleSearchCustomers = (query) => {
    // Limpa o timer anterior se o usuário continuar digitando
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Se a busca tiver menos de 2 caracteres, limpa a lista e não faz requisição
    if (!query || query.trim().length < 2) {
      this.setState({ customersList: [], loadingCustomers: false });
      return;
    }

    this.setState({ loadingCustomers: true });

    // Aguarda 400ms após o usuário parar de digitar antes de fazer o fetch
    this.searchTimeout = setTimeout(async () => {
      try {
        const response = await fetch(`${apiUrl}/customers/search?q=${encodeURIComponent(query)}`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("userToken"),
          },
        });
        const data = await response.json();
        this.setState({ customersList: data, loadingCustomers: false });
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
        this.setState({ customersList: [], loadingCustomers: false });
      }
    }, 400);
  };

  handleAbrirComanda = (mesa) => {


    this.setState({
      itensTable: mesa.itens,
      mesaSelecionada: mesa,
      modalComandaAberto: true
    });

    return;
    this.setState({ loading: true });
    fetch(`${apiUrl}/tables/${mesa.id}`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("userToken"),
      },
    }).then((response) => {
      this.setState({ loading: false });
      if (response.status === 200) {
        response.json().then((data) => {
          this.setState({
            itensTable: data,
            mesaSelecionada: mesa,
            modalComandaAberto: true
          });
        });
      } else {
        toast.error("Erro ao carregar itens da comanda.");
      }
    }).catch(() => this.setState({ loading: false }));
  };

  handleIniciarFinalizacao = (mesa) => {
    this.setState({
      mesaSelecionada: mesa,
      modalPagamentoAberto: true,
      metodoPagamentoAtual: 'money',
      valorInseridoAtual: mesa.total ? parseFloat(mesa.total) : 0, // Sugere o valor total de cara
      pagamentosLancados: []
    });
  };

  handleMetodoPagamentoChange = (event, novoMetodo) => {
    if (novoMetodo !== null) {
      const { mesaSelecionada, pagamentosLancados } = this.state;
      const totalMesa = mesaSelecionada ? mesaSelecionada.total : 0;
      const totalPagoAteAgora = pagamentosLancados.reduce((acc, curr) => acc + curr.valor, 0);
      const restante = totalMesa - totalPagoAteAgora;

      this.setState({
        metodoPagamentoAtual: novoMetodo,
        valorInseridoAtual: restante > 0 ? restante.toFixed(2) : 0 // Facilita o preenchimento automático do restante
      });
    }
  };

  handleAdicionarPagamento = () => {
    const { valorInseridoAtual, metodoPagamentoAtual, mesaSelecionada, pagamentosLancados } = this.state;
    const valor = parseFloat(valorInseridoAtual);

    if (!valor || valor <= 0) {
      toast.error('Insira um valor válido para lançar.');
      return;
    }

    const totalMesa = mesaSelecionada ? mesaSelecionada.total : 0;
    const totalPagoAteAgora = pagamentosLancados.reduce((acc, curr) => acc + curr.valor, 0);
    const restante = parseFloat((totalMesa - totalPagoAteAgora).toFixed(2));

    if (metodoPagamentoAtual !== 'money' && valor > restante) {
      toast.error(`Para ${metodoPagamentoAtual.toUpperCase()}, o valor não pode ultrapassar o saldo restante (R$ ${restante.toFixed(2)}).`);
      return;
    }

    const novoPagamento = {
      metodo: metodoPagamentoAtual,
      valor: valor
    };

    this.setState(prevState => {
      const novosPagamentos = [...prevState.pagamentosLancados, novoPagamento];
      const novoTotalPago = novosPagamentos.reduce((acc, curr) => acc + curr.valor, 0);
      const novoRestante = totalMesa - novoTotalPago;
      return {
        pagamentosLancados: novosPagamentos,
        valorInseridoAtual: novoRestante > 0 ? novoRestante.toFixed(2) : 0
      };
    });
  };

  handleRemoverPagamentoLancado = (index) => {
    this.setState(prevState => {
      const novosPagamentos = prevState.pagamentosLancados.filter((_, i) => i !== index);
      const totalMesa = prevState.mesaSelecionada ? prevState.mesaSelecionada.total : 0;
      const novoTotalPago = novosPagamentos.reduce((acc, curr) => acc + curr.valor, 0);
      const novoRestante = totalMesa - novoTotalPago;
      return {
        pagamentosLancados: novosPagamentos,
        valorInseridoAtual: novoRestante > 0 ? novoRestante.toFixed(2) : 0
      };
    });
  };
  printThermalReceipt = (mesa, pagamentos, totalPago, troco) => {
    const dataHora = new Date().toLocaleString('pt-BR');

    // Garante que pegamos os itens diretamente do objeto da mesa passada por parâmetro
    const listaItens = mesa.itens || [];

    // Monta as linhas de produtos do extrato
    const itensHtml = listaItens.map(item => `
      <tr>
        <td style="padding: 4px 0; font-size: 12px;">
          ${item.produto_name}<br>
          <small>${item.quantidade}x ${Number(item.valor_venda).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
        </td>
        <td style="text-align: right; vertical-align: bottom; font-size: 12px;">
          ${Number(item.valor_total || (item.valor_venda * item.quantidade)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
        </td>
      </tr>
    `).join('');

    // Monta as formas de pagamento utilizadas
    const pagamentosHtml = pagamentos.map(p => `
      <div style="display: flex; justify-content: space-between; font-size: 12px; margin-bottom: 2px;">
        <span>${p.metodo.toUpperCase()}:</span>
        <span>${Number(p.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
      </div>
    `).join('');

    // Abre a janela de impressão
    const WinPrint = window.open('', '', 'width=800,height=600');

    WinPrint.document.write(`
      <html>
        <head>
          <title>Cupom Mesa #${mesa.code}</title>
          <style>
            @page { size: auto; margin: 0mm; }
            body {
              font-family: 'Courier New', Courier, monospace;
              width: 72mm;
              margin: 0;
              padding: 4mm 4mm;
              font-size: 12px;
              line-height: 1.3;
              color: #000;
            }
            .text-center { text-align: center; }
            .divider { border-top: 1px dashed #000; margin: 8px 0; }
            .header h2 { margin: 0 0 5px 0; font-size: 16px; font-weight: bold; }
            .header p { margin: 2px 0; font-size: 11px; }
            table { width: 100%; border-collapse: collapse; }
            .total-box { font-size: 13px; font-weight: bold; margin-top: 5px; }
            .footer { margin-top: 20px; font-size: 11px; }
          </style>
        </head>
        <body>
          <div class="header text-center">
            <h2>FazPedido</h2>
            <p>Extrato de Conta Eletrônico</p>
            <p>${dataHora}</p>
          </div>
          
          <div class="divider"></div>
          
          <div style="font-size: 13px; font-weight: bold; text-align: center;">
            MESA CONTROLE: #${mesa.code}
          </div>
          
          <div class="divider"></div>
          
          <table>
            <thead>
              <tr>
                <th style="text-align: left; font-size: 12px; padding-bottom: 5px;">Item</th>
                <th style="text-align: right; font-size: 12px; padding-bottom: 5px;">Total</th>
              </tr>
            </thead>
            <tbody>
              ${itensHtml}
            </tbody>
          </table>
          
          <div class="divider"></div>
          
          <div class="total-box">
            <div style="display: flex; justify-content: space-between;">
              <span>TOTAL DA COMANDA:</span>
              <span>${Number(mesa.total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
            </div>
          </div>
          
          <div class="divider"></div>
          
          <div style="font-weight: bold; margin-bottom: 5px; font-size: 11px;">PAGAMENTOS RECEBIDOS:</div>
          ${pagamentosHtml}
          
          <div class="divider"></div>
          
          <div style="display: flex; justify-content: space-between; font-size: 13px; font-weight: bold;">
            <span>TOTAL PAGO:</span>
            <span>${Number(totalPago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
          </div>
          ${troco > 0 ? `
          <div style="display: flex; justify-content: space-between; font-size: 13px; font-weight: bold; margin-top: 3px;">
            <span>TROCO:</span>
            <span>${Number(troco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
          </div>
          ` : ''}
          
          <div class="divider"></div>
          
          <div class="footer text-center">
            <p>Obrigado pela preferência!</p>
            <p>Volte Sempre</p>
          </div>
          
          <script>
            window.onload = function() {
              window.print();
              setTimeout(function() { window.close(); }, 300);
            };
          <\/script>
        </body>
      </html>
    `);

    WinPrint.document.close();
    WinPrint.focus();
  };
  handleFinalizarEFecharMesa = () => {
    const { mesaSelecionada, pagamentosLancados, loading } = this.state;
    if (!mesaSelecionada || loading) return;
    const totalMesa = mesaSelecionada.total;
    const totalPago = pagamentosLancados.reduce((acc, curr) => acc + curr.valor, 0);

    if (totalPago < totalMesa) {
      toast.error('O valor total pago ainda é inferior ao total da comanda.');
      return;
    }

    const trocoCalculado = totalPago > totalMesa ? totalPago - totalMesa : 0;

    this.setState({ loading: true });

    const dadosPagamento = {
      mesaId: mesaSelecionada.id,
      pagamentos: pagamentosLancados,
      totalPago: totalPago,
      troco: trocoCalculado,
      status: 'open'
    };


    fetch(`${apiUrl}/tables/${mesaSelecionada.id}/checkout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("userToken"),
      },
      body: JSON.stringify(dadosPagamento)
    }).then((response) => {
      this.setState({ loading: false });
      if (response.ok) {
        this.printThermalReceipt(mesaSelecionada, pagamentosLancados, totalPago, trocoCalculado);
        this.setState(prevState => ({
          mesas: prevState.mesas.map(m =>
            m.id === mesaSelecionada.id ? { ...m, status: 0, total: 0.00 } : m
          ),
          modalPagamentoAberto: false,
          modalComandaAberto: false,
          mesaSelecionada: null,
          pagamentosLancados: []
        }));
        toast.success('Atendimento finalizado com sucesso! Mesa liberada.');
      } else {
        toast.error('Erro ao finalizar o atendimento no servidor.');
      }
    }).catch(() => this.setState({ loading: false }));
  };

  handleTrocarMesa = () => {
    const { mesaSelecionada, mesaDestinoId, loading } = this.state;
    if (!mesaDestinoId || loading) {
      toast.error("Selecione uma mesa de destino.");
      return;
    }

    this.setState({ loading: true });

    fetch(`${apiUrl}/tables/transfer`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("userToken"),
      },
      body: JSON.stringify({
        origemMesaId: mesaSelecionada.id,
        destinoMesaId: parseInt(mesaDestinoId, 10)
      })
    }).then((response) => {
      this.setState({ loading: false });
      if (response.ok) {
        toast.success("Consumo transferido com sucesso!");
        this.LoadTables();
        this.setState({ modalTrocarMesaAberto: false, mesaSelecionada: null, mesaDestinoId: '' });
      } else {
        toast.error("Erro ao transferir mesa. Verifique se a mesa de destino está livre.");
      }
    }).catch(() => this.setState({ loading: false }));
  };

  handleCadastrarMesa = (e) => {
    e.preventDefault();
    const { cadastroCodigo, cadastroCapacidade, loading } = this.state;

    if (!cadastroCodigo || !cadastroCapacidade || loading) {
      toast.error('Por favor, preencha todos os campos do cadastro.');
      return;
    }

    this.setState({ loading: true });

    const novaMesa = {
      code: `${cadastroCodigo.padStart(2, '0')}`,
      capacidade: parseInt(cadastroCapacidade, 10),
      status: 'open',
      total: 0.00
    };

    fetch(`${apiUrl}/tables`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("userToken"),
      },
      body: JSON.stringify(novaMesa)
    }).then((response) => {
      this.setState({ loading: false });
      if (response.ok) {
        this.LoadTables();
        this.setState({ cadastroCodigo: '', cadastroCapacidade: '' });
        toast.success('Mesa cadastrada com sucesso!');
      } else {
        toast.error('Erro ao cadastrar mesa.');
      }
    }).catch(() => this.setState({ loading: false }));
  };

  handleRemoverMesaCompleta = (id) => {
    if (!window.confirm("Tem certeza que deseja excluir permanentemente esta mesa do sistema?")) return;

    fetch(`${apiUrl}/tables/${id}`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("userToken"),
      }
    }).then((response) => {
      if (response.ok) {
        this.LoadTables();
        toast.success('Mesa removida com sucesso.');
      } else {
        toast.error('Erro ao remover mesa.');
      }
    });
  };

  handleAbrirMesa = (mesa) => {
    console.log(mesa)
    this.setState({
      openTable: {
        id: mesa.id,
        code: mesa.code
      }
    })

    return;


    fetch(`${apiUrl}/tables/${mesa.id}/open`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      }
    }).then((response) => {
      if (response.ok) {
        toast.success('Mesa aberta com sucesso!');
        this.setState(prevState => ({
          mesas: prevState.mesas.map(m =>
            m.id === mesa.id ? { ...m, status: 'close', total: 0, itens: [] } : m
          )
        }));
      } else {
        toast.error('Erro ao abrir a mesa.');
      }
    });
  };


  printWithAgentCozinha = (mesaCode, itensObjeto, print) => {
    const printData = this.context?.printData;
    const horaAtual = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    const listaItens = Object.values(itensObjeto || {});

    let itensTexto = '';
    listaItens.forEach(item => {
      // 1. QUANTIDADE + NOME DO ITEM (Fonte Encorpada/Expandida)
      itensTexto += `\x1b\x45\x01\x1b\x21\x20${item.quantidade}x ${item.nome.toUpperCase()}\x1b\x21\x00\x1b\x45\x00\n`;

      // 2. OBSERVAÇÃO COM DESTAQUE
      if (item.observacao && item.observacao.trim() !== '') {
        itensTexto += `\x1b\x45\x01   * OBS: ${item.observacao.trim().toUpperCase()}\x1b\x45\x00\n`;
      }

      // Linha de separação
      itensTexto += '--------------------------------\n';
    });

    // Payload formatado com caracteres de controle reais (\x1b)
    const payloadEscPos =
      '\x1b\x40' +                          // Reset / Inicializa impressora
      '\x1b\x42\x02\x01' +                  // Beep duplo
      '\x1b\x61\x01' +                      // Centralizar cabeçalho
      '================================\n' +
      '\x1b\x45\x01\x1b\x21\x30' +          // Título Expandido/Negrito
      `MESA #${mesaCode}\n` +
      '\x1b\x21\x00\x1b\x45\x00' +          // Volta ao estilo normal
      `HORA: ${horaAtual}  |  VIA COZINHA\n` +
      '================================\n\n' +
      '\x1b\x61\x00' +                      // Alinhar itens à esquerda
      itensTexto +
      '================================\n' +
      '\x1b\x61\x01' +                      // Centralizar rodapé
      '\x1b\x45\x01\x1b\x21\x10' +
      '=== FIM DO PEDIDO ===\n' +
      '\x1b\x21\x00\x1b\x45\x00\n\n' +
      '\x1b\x42\x02\x01';                   // Beep de encerramento

    if (typeof printData === 'function') {
      printData(payloadEscPos, print);
    }
  };



  printWithAgent = (mesaCode, itensObjeto, print) => {
    const printData = this.context?.printData;
    const horaAtual = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    const listaItens = Object.values(itensObjeto || {});

    let itensTexto = '';
    listaItens.forEach(item => {
      // 1. QUANTIDADE + NOME DO ITEM (Fonte Encorpada, Larga e Escura)
      // \x1b\x45\x01 (Negrito ligado) + \x1b\x21\x20 (Tamanho Expandido Encorpado)
      itensTexto += `\\x1b\\x45\\x01\\x1b\\x21\\x20${item.quantidade}X ${item.nome.toUpperCase()}\\x1b\\x21\\x00\\x1b\\x45\\x00\n`;

      // 2. OBSERVAÇÃO COM ESPAÇAMENTO E DESTAQUE (Texto em caixa de alerta)
      if (item.observacao && item.observacao.trim() !== '') {
        itensTexto += `\\x1b\\x45\\x01  [!] OBS: ${item.observacao.trim().toUpperCase()}\\x1b\\x45\\x00\n`;
      }

      // Linha de separação com respiro (espaço antes e depois para não "amontoar" a leitura)
      itensTexto += '\n--------------------------------\n\n';
    });

    // Payload com hierarquia visual e tipografia de alto contraste para 58mm
    const payloadEscPos =
      '\\x1b\\x40' +                          // Reset / Inicializa impressora
      '\\x1b\\x42\\x02\\x01' +                  // Beep duplo alto
      '\\x1b\\x61\\x01' +                      // Centralizar cabeçalho
      '================================\n' +
      '\\x1b\\x45\\x01\\x1b\\x21\\x30' +          // Título GIGANTE e GROSSO
      `MESA #${mesaCode}\n` +
      '\\x1b\\x21\\x00\\x1b\\x45\\x00' +          // Volta ao padrão
      `HORA: ${horaAtual}  |  VIA COZINHA\n` +
      '================================\n\n' +
      '\\x1b\\x61\\x00' +                      // Alinhar itens à esquerda
      itensTexto +
      '\\x1b\\x61\\x01' +                      // Centralizar rodapé
      '\\x1b\\x45\\x01\\x1b\\x21\\x10' +
      '=== FIM DO PEDIDO ===\n' +
      '\\x1b\\x21\\x00\\x1b\\x45\\x00\n\n\n\n\n' +
      '\\x1b\\x42\\x02\\x01';                   // Beep de encerramento

    printData(payloadEscPos, print);
  };



  printWithBrowser = (mesaCode, itensObjeto) => {

    const dataHora = new Date().toLocaleString('pt-BR');


    // Converte o objeto indexado em uma Array de produtos tratável

    const listaItens = Object.values(itensObjeto || {});


    // Monta as linhas focando na quantidade, nome e observações para a cozinha

    const itensHtml = listaItens.map(item => {

      // Verifica se há alguma observação (ex: "Sem cebola", "Bem passado")

      const temObservacao = item.observacao && item.observacao.trim() !== "";


      return `

<tr>

<td style="font-size: 20px; font-weight: bold; padding: 6px 0; border-bottom: 1px dashed #ccc; line-height: 1.2;">

${item.quantidade}x ${item.nome}

${temObservacao ? `<br><span style="font-size: 14px; font-weight: normal; color: #333; background-color: #eee; padding: 2px 4px; display: inline-block; margin-top: 4px;">OBS: ${item.observacao}</span>` : ''}

</td>

</tr>

`;

    }).join('');


    const WinPrint = window.open('', '', 'width=800,height=600');


    WinPrint.document.write(`

<html>

<head>

<title>Cozinha - Mesa #${mesaCode}</title>

<style>

@page { size: auto; margin: 0mm; }

body {

font-family: 'Courier New', Courier, monospace;

width: 72mm;

margin: 0;

padding: 4mm 4mm;

color: #000;

}

.text-center { text-align: center; }

.divider { border-top: 2px dashed #000; margin: 8px 0; }

.header h2 { margin: 0; font-size: 22px; font-weight: bold; letter-spacing: 1px; }

.header p { margin: 4px 0; font-size: 12px; }

.mesa-destaque { font-size: 28px; font-weight: bold; background: #000; color: #fff; text-align: center; padding: 5px 0; margin: 5px 0; }

table { width: 100%; border-collapse: collapse; }

</style>

</head>

<body>

<div class="header text-center">

<h2>PEDIDO COZINHA</h2>

<p>${dataHora}</p>

</div>

<div class="divider"></div>

<div class="mesa-destaque">

MESA #${mesaCode}

</div>

<div class="divider"></div>

<table>

<tbody>

${itensHtml}

</tbody>

</table>

<div class="divider"></div>

<div class="text-center" style="margin-top: 15px; font-size: 11px;">

* Fim do Pedido *

</div>

<script>

window.onload = function() {

window.print();

setTimeout(function() { window.close(); }, 300);

};

<\/script>

</body>

</html>

`);


    WinPrint.document.close();

    WinPrint.focus();

  };




  render() {
    const {
      mesas, tabAtual, modalComandaAberto, modalPagamentoAberto, modalTrocarMesaAberto, mesaSelecionada,
      itensTable, metodoPagamentoAtual, valorInseridoAtual, pagamentosLancados,
      cadastroCodigo, cadastroCapacidade, mesaDestinoId, loading, anchorEl, now
    } = this.state;
    const open = Boolean(anchorEl);
    const mesasFiltradas = mesas.filter(m => {
      if (tabAtual === 1) return m.status === 'open';
      if (tabAtual === 2) return m.status === 'close';
      return true;
    });

    const totalMesa = mesaSelecionada ? mesaSelecionada.total : 0;
    const totalPagoAteAgora = pagamentosLancados.reduce((acc, curr) => acc + curr.valor, 0);
    const saldoRestante = totalMesa - totalPagoAteAgora > 0 ? totalMesa - totalPagoAteAgora : 0;
    const trocoCalculado = totalPagoAteAgora > totalMesa ? totalPagoAteAgora - totalMesa : 0;

    return (
      <Box sx={{ p: 0 }}>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3, display: "none" }}>
          <Tabs value={tabAtual} onChange={this.handleTabChange}>
            <Tab label={`Todas (${mesas.length})`} />
            <Tab label={`Livres (${mesas.filter(m => m.status === 'open').length})`} />
            <Tab label={`Ocupadas (${mesas.filter(m => m.status === 'close').length})`} />
            <Tab label="Configurar Mesas" />
            <Tab label="Impressão" />
          </Tabs>
        </Box>

        {tabAtual <= 2 && (
          <Grid
            container
            spacing={2}
            sx={{
              p: 2,
              backgroundColor: '#f4f6f8',
              height: 'calc(100vh - 80px)', // Mantém a altura cravada no viewport disponível
              overflow: 'hidden', // Evita o scroll na janela/página principal
            }}
          >
            {/* COLUNA ESQUERDA: PAINEL E LISTA DE MESAS */}
            <Grid
              item
              component={Paper}
              elevation={2}
              size={{ xs: 12, md: 8 }}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflowY: 'auto', // Scroll independente na lista de mesas
                borderRadius: 2,
              }}
            >
              <Box sx={{ p: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                  Mesas
                </Typography>
              </Box>
              <Divider />

              {/* Mesas Abertas (status === 1) */}
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 1.5,
                  p: 2,
                }}
              >
                {mesas
                  .filter((mesa) => mesa.status === 1)
                  .map((mesa) => (
                    <Paper
                      key={mesa.id || mesa.numero}
                      elevation={0}
                      onClick={() => {
                        fetch(`${apiUrl}/tables/${mesa.id}`, {
                          method: 'GET',
                          credentials: 'include',
                          headers: {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + localStorage.getItem('userToken'),
                          },
                        })
                          .then((response) => {
                            // Verifica se a resposta foi bem-sucedida (ex: 200 OK)
                            if (!response.ok) {
                              throw new Error('Erro ao buscar detalhes da mesa');
                            }
                            return response.json(); // <-- Retorna a promise do JSON para o próximo .then()
                          })
                          .then((data) => {
                            this.setState({ mesaSelecionada: data })
                          })
                          .catch((error) => {
                            console.error('Erro na requisição:', error);
                          });
                      }}
                      sx={{
                        width: 170,
                        backgroundColor: '#4cd985',
                        borderRadius: 2,
                        border: '1.5px solid #4cd985',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        transition: '0.2s',
                        '&:hover': { opacity: 0.9 },
                      }}
                    >
                      {/* Cabeçalho Verde */}
                      <Box sx={{ p: 0.5, textAlign: 'center', color: '#1a1a1a' }}>
                        <Typography sx={{ fontSize: '0.75rem', fontWeight: 'bold' }}>
                          MESA {mesa.code} {mesa.nome ? `(${mesa.nome})` : ''}
                        </Typography>
                      </Box>

                      {/* Corpo Branco */}
                      <Box
                        sx={{
                          backgroundColor: '#ffffff',
                          borderRadius: '6px',
                          p: 1.2,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 0.8,
                        }}
                      >
                        <Typography sx={{ fontSize: '1.1rem', color: '#666', fontWeight: 500 }}>
                          R$ {mesa.total ? mesa.total.toFixed(2).replace('.', ',') : '0,00'}
                        </Typography>



                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pt: 0.3 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                            <AccessTimeIcon sx={{ fontSize: 15, color: '#777' }} />
                            <Typography sx={{ fontSize: '0.7rem', color: '#777' }}>
                              {this.formatDuration(mesa.opened_by) || '0min'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                            <Typography sx={{ fontSize: '0.7rem', color: '#777' }}>
                              {mesa.persons || 0}
                            </Typography>
                            <PeopleIcon sx={{ fontSize: 15, color: '#777' }} />
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  ))}
              </Box>

              {/* Mesas Livres (status === 0) */}
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 1.5,
                  p: 2,
                }}
              >
                {mesas
                  .filter((mesa) => mesa.status === 0)
                  .map((mesa) => (
                    <Paper
                      key={mesa.id || mesa.numero}
                      elevation={0}
                      onClick={() => this.handleAbrirMesa(mesa)}
                      sx={{
                        width: 90,
                        height: 65,
                        backgroundColor: '#e2e7ec',
                        borderRadius: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: '0.2s',
                        '&:hover': { backgroundColor: '#d3dbe3' },
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: '0.65rem',
                          fontWeight: 600,
                          color: '#555',
                          letterSpacing: 0.5,
                        }}
                      >
                        MESA
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 'bold',
                          fontSize: '1.1rem',
                          color: '#333',
                          lineHeight: 1.1,
                        }}
                      >
                        {mesa.code}
                      </Typography>
                    </Paper>
                  ))}
              </Box>
            </Grid>



            {/* COLUNA DIREITA: DETALHES DA MESA SELECIONADA */}
            <Grid
              item
              component={Paper}
              elevation={2}
              size={{ xs: 12, md: 4 }}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%', // Ajustado de 100vh para 100% para não estourar o container
                justifyContent: 'space-between',
                borderRadius: 2,
                overflow: 'hidden',
                bgcolor: '#ffffff',
                position: 'relative',
              }}
            >
              {!mesaSelecionada ? (
                /* ESTADO VAZIO: Nenhuma mesa selecionada */
                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 3,
                    textAlign: 'center',
                  }}
                >
                  <InventoryIcon sx={{ fontSize: 90, color: '#d0d0d0', mb: 2 }} />
                  <Typography sx={{ color: '#666', fontWeight: 'bold', fontSize: '1.05rem', mb: 0.5 }}>
                    Nenhuma mesa ou comanda selecionada
                  </Typography>
                  <Typography sx={{ color: '#999', fontSize: '0.85rem' }}>
                    Selecione uma mesa ou comanda para ver mais informações sobre ela
                  </Typography>
                </Box>
              ) : (
                /* CONTEÚDO DA MESA SELECIONADA */
                <>
                  {/* 1. CABEÇALHO */}
                  <Box sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box
                          sx={{
                            width: 42,
                            height: 42,
                            borderRadius: 2,
                            bgcolor: '#93eab3',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography sx={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#1a5d36' }}>
                            {mesaSelecionada.code}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                            <Box component="span" sx={{ color: '#4caf50' }}>Aberta</Box> • Pedido #{mesaSelecionada.order}
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#888' }}>
                            Mesa aberta hoje às {mesaSelecionada.hora || '16:41'}
                          </Typography>
                        </Box>
                      </Box>
                      <IconButton size="small">
                        <EditIcon sx={{ fontSize: 18, color: '#666' }} />
                      </IconButton>
                    </Box>

                    {/* Tags de Informação */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Box sx={tagStyle}>
                          <BadgeIcon sx={{ fontSize: 16, color: '#666' }} />
                          <Typography noWrap sx={textTagStyle}>{mesaSelecionada.description || 'Não Informado'}</Typography>
                        </Box>
                        <Box sx={tagStyle}>
                          <PeopleIcon sx={{ fontSize: 16, color: '#666' }} />
                          <Typography noWrap sx={textTagStyle}>{mesaSelecionada.persons} pessoas</Typography>
                        </Box>
                      </Box>

                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Box sx={tagStyle}>
                          <PersonIcon sx={{ fontSize: 16, color: '#666' }} />
                          <Typography noWrap sx={textTagStyle}>{mesaSelecionada.client || 'Não Informado'}</Typography>
                        </Box>
                        <Box sx={tagStyle}>
                          <RoomServiceIcon sx={{ fontSize: 16, color: '#666' }} />
                          <Typography noWrap sx={textTagStyle}>{mesaSelecionada.bartender || 'Não Informado'}</Typography>
                        </Box>
                        <Box sx={{ ...tagStyle, width: 'auto', minWidth: 50 }}>
                          <LockIcon sx={{ fontSize: 16, color: '#666' }} />
                          <Typography sx={textTagStyle}>{mesaSelecionada.code}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Divider />

                  {/* 2. ITENS LANÇADOS / ESTADO VAZIO DO PEDIDO */}
                  {mesaSelecionada.itens && mesaSelecionada.itens.length > 0 ? (
                    <Box sx={{ flex: 1, p: 2, overflowY: 'auto' }}>
                      <Typography sx={{ color: '#888', fontSize: '0.8rem', mb: 1 }}>
                        Itens lançados
                      </Typography>
                      {mesaSelecionada.itens.map((item) => (
                        <Box key={item.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                          <Typography sx={{ fontSize: '0.9rem', fontWeight: 500 }}>
                            {item.quantidade}x {item.produto_name}
                          </Typography>
                          <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                            R$ {Number(item.valor_total).toFixed(2).replace('.', ',')}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 2,
                        textAlign: 'center',
                      }}
                    >
                      <InventoryIcon sx={{ fontSize: 90, color: '#d0d0d0', mb: 2 }} />
                      <Typography sx={{ color: '#999', fontWeight: '500', fontSize: 18 }}>
                        Ainda não há nenhum pedido
                      </Typography>
                      <Button
                        startIcon={<AddIcon />}
                        sx={{
                          mt: 2,
                          color: '#a033ff',
                          fontWeight: 'bold',
                          fontSize: '0.85rem',
                          textTransform: 'uppercase',
                          px: 2,
                          py: 1,
                          '&:hover': { bgcolor: '#f4e8ff' },
                        }}
                        onClick={() => {
                          fetch(`${apiUrl}/store/menu`, {
                            method: 'GET',
                            credentials: 'include',
                            headers: {
                              'Content-Type': 'application/json',
                              Authorization: 'Bearer ' + localStorage.getItem('userToken'),
                            },
                          }).then((response) => {
                            response.json().then((data) => {
                              this.setState({ dadosCategorias: data, dialogAberto: true });
                            });
                          });
                        }}
                      >
                        ADICIONAR PEDIDO
                      </Button>
                    </Box>
                  )}

                  <Divider />

                  {/* 3. RODAPÉ E AÇÕES */}
                  <Box sx={{ p: 2, bgcolor: '#fafafa' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Typography sx={{ fontWeight: 'bold', color: '#666' }}>Subtotal</Typography>
                      <Typography sx={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#444' }}>
                        {mesaSelecionada.total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || 'R$ 0,00'}
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <IconButton
                        onClick={this.handleOpenMenu}
                        sx={{ border: '1px solid #e0e0e0', borderRadius: 2, p: 1, bgcolor: '#fff' }}
                      >
                        <KeyboardArrowUpIcon sx={{ color: '#666' }} />
                      </IconButton>

                      <IconButton sx={{ border: '1px solid #e0e0e0', borderRadius: 2, p: 1, bgcolor: '#fff' }}
                        onClick={() => {
                          fetch(`${apiUrl}/store/menu`, {
                            method: 'GET',
                            credentials: 'include',
                            headers: {
                              'Content-Type': 'application/json',
                              Authorization: 'Bearer ' + localStorage.getItem('userToken'),
                            },
                          }).then((response) => {
                            response.json().then((data) => {
                              this.setState({ dadosCategorias: data, dialogAberto: true });
                            });
                          });
                        }}>
                        <AddIcon sx={{ color: '#666' }} />
                      </IconButton>

                      <IconButton sx={{ border: '1px solid #e0e0e0', borderRadius: 2, p: 1, bgcolor: '#fff' }}
                        onClick={() => {
                          this.handleIniciarFinalizacao(this.state.mesaSelecionada)
                        }}
                      >
                        <AttachMoneyIcon sx={{ color: '#666' }} />
                      </IconButton>

                      <Button
                        variant="contained"
                        fullWidth
                        disabled={!mesaSelecionada.itens || mesaSelecionada.itens.length === 0}
                        onClick={() => this.handleIniciarFinalizacao(mesaSelecionada)}
                        sx={{
                          bgcolor: '#a033ff',
                          color: '#fff',
                          fontWeight: 'bold',
                          borderRadius: 2,
                          boxShadow: 'none',
                          '&:hover': { bgcolor: '#8b22e0' },
                        }}
                      >
                        FECHAR CONTA
                      </Button>
                    </Box>
                  </Box>

                  {/* MENU POPOVER */}
                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={this.handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    PaperProps={{
                      sx: {
                        borderRadius: 2,
                        boxShadow: '0px 4px 20px rgba(0,0,0,0.12)',
                        minWidth: 200,
                        mb: 1,
                      },
                    }}
                  >
                    <MenuItem onClick={this.handleCloseMenu}>
                      <ListItemIcon><LockIcon fontSize="small" /></ListItemIcon>
                      <ListItemText primary="Bloquear mesa" />
                    </MenuItem>
                    <MenuItem onClick={this.handleCloseMenu}>
                      <ListItemIcon><OpenInNewIcon fontSize="small" /></ListItemIcon>
                      <ListItemText primary="Ver link da mesa" />
                    </MenuItem>
                    <MenuItem onClick={this.handleCloseMenu}>
                      <ListItemIcon><ReceiptLongIcon fontSize="small" /></ListItemIcon>
                      <ListItemText primary="Ver resumo da conta" />
                    </MenuItem>
                    <MenuItem onClick={this.handleCloseMenu}>
                      <ListItemIcon><SwapHorizIcon fontSize="small" /></ListItemIcon>
                      <ListItemText primary="Trocar mesa/comanda" />
                    </MenuItem>
                    <MenuItem onClick={this.handleCloseMenu}>
                      <ListItemIcon><ReplyIcon fontSize="small" /></ListItemIcon>
                      <ListItemText primary="Transferir itens" />
                    </MenuItem>
                    <MenuItem onClick={this.handleCloseMenu}>
                      <ListItemIcon><PrintIcon fontSize="small" /></ListItemIcon>
                      <ListItemText primary="Reimprimir itens" />
                    </MenuItem>
                    <MenuItem onClick={this.handleCloseMenu}>
                      <ListItemIcon><RemoveCircleOutlineIcon fontSize="small" /></ListItemIcon>
                      <ListItemText primary="Cancelar itens" />
                    </MenuItem>
                    <MenuItem name="cancelar" onClick={() => {
                      this.setState({ anchorEl: null, cancelar: this.state.mesaSelecionada });
                    }} sx={{ color: 'error.main' }}>
                      <ListItemIcon><CloseIcon fontSize="small" color="error" /></ListItemIcon>
                      <ListItemText primary="Cancelar Pedido" />
                    </MenuItem>
                  </Menu>
                </>
              )}
            </Grid>
          </Grid>
        )}

        {
          false && (
            <Grid container spacing={3}>
              {mesasFiltradas.map((mesa) => {
                const ehOcupada = mesa.status === 'close';

                return (
                  <Grid item xs={12} size={{ sm: 3 }} key={mesa.id}>
                    <Card sx={{
                      borderTop: 5,
                      borderColor: ehOcupada ? 'error.main' : 'success.main',
                      boxShadow: 2
                    }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                            #{mesa.code}
                          </Typography>
                          <Chip
                            label={ehOcupada ? 'Ocupada' : 'Livre'}
                            color={ehOcupada ? 'error' : 'success'}
                            size="small"
                          />
                        </Box>
                        <Typography variant="body1" sx={{ fontWeight: ehOcupada ? 'bold' : 'normal' }}>
                          Consumo: {mesa.total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </Typography>
                      </CardContent>

                      <CardActions sx={{ flexDirection: 'column', gap: 1, p: 2, backgroundColor: '#fafafa' }}>
                        {ehOcupada ? (
                          <>
                            {mesa.status === "close" && mesa.total > 0 ? (
                              <Box sx={{ display: 'flex', gap: 1, width: '100%', justifyContent: 'space-between' }}>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  startIcon={<TableBar />}
                                  onClick={() => this.handleAbrirComanda(mesa)}
                                >
                                  Comanda
                                </Button>



                                <Button
                                  size="small"
                                  variant="contained"
                                  color="error"
                                  startIcon={<CancelIcon />}
                                  onClick={() => {
                                    this.setState({ cancelar: mesa })
                                  }}
                                >
                                  Cancelar
                                </Button>
                              </Box>
                            ) : (
                              <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
                                <Button

                                  size="small"
                                  variant="outlined"
                                  onClick={() => {
                                    fetch(`${apiUrl}/store/menu`, {
                                      method: "GET",
                                      credentials: "include",
                                      headers: {
                                        "Content-Type": "application/json",
                                        Authorization: "Bearer " + localStorage.getItem("userToken"),
                                      },
                                    }).then((response) => {
                                      response.json().then((data) => {
                                        this.setState({ dadosCategorias: data, dialogAberto: true, mesaSelecionada: mesa });
                                      });
                                    })
                                  }}
                                >
                                  Lançar Itens
                                </Button>
                                <Button
                                  size="small"
                                  variant="contained"
                                  color="error"
                                  startIcon={<DoDisturbOnIcon />}
                                  onClick={() => {
                                    fetch(`${apiUrl}/tables/close/${mesa.id}`, {
                                      method: "DELETE",
                                      credentials: "include",
                                      headers: {
                                        "Content-Type": "application/json",
                                        Authorization: "Bearer " + localStorage.getItem("userToken"),
                                      },
                                    }).then((response) => {
                                      if (response.status === 200) {
                                        toast.success("Mesa fechada!");
                                        this.LoadTables();
                                      }
                                    });
                                  }}
                                >
                                  Liberar
                                </Button>
                              </Box>
                            )}
                          </>
                        ) : (
                          <Button
                            fullWidth
                            size="small"
                            variant="contained"
                            color="success"
                            startIcon={<CheckCircle />}
                            onClick={() => this.handleAbrirMesa(mesa)}
                          >
                            Abrir Mesa
                          </Button>
                        )}
                      </CardActions>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          )
        }

        {/* ABA DE CONFIGURAÇÃO */}
        {
          tabAtual === 3 && (
            <Grid container spacing={4}>
              <Grid item xs={12} md={4}>
                <Paper sx={{ p: 3, boxShadow: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>Cadastrar Nova Mesa</Typography>
                  <form onSubmit={this.handleCadastrarMesa}>
                    <TextField
                      fullWidth
                      label="Número da Mesa (Ex: 05)"
                      variant="outlined"
                      margin="normal"
                      value={cadastroCodigo}
                      onChange={(e) => this.setState({ cadastroCodigo: e.target.value })}
                    />
                    <TextField
                      fullWidth
                      label="Capacidade de Cadeiras"
                      type="number"
                      variant="outlined"
                      margin="normal"
                      value={cadastroCapacidade}
                      onChange={(e) => this.setState({ cadastroCapacidade: e.target.value })}
                    />
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      color="primary"
                      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Add />}
                      disabled={loading}
                      sx={{ mt: 2 }}
                    >
                      Adicionar ao Sistema
                    </Button>
                  </form>
                </Paper>
              </Grid>

              <Grid item xs={12} md={8}>
                <Paper sx={{ p: 3, boxShadow: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>Mesas Ativas</Typography>
                  <List>
                    {mesas.map((m) => (
                      <React.Fragment key={m.id}>
                        <ListItem
                          secondaryAction={
                            <IconButton edge="end" color="error" disabled={m.status === 'close'} onClick={() => this.handleRemoverMesaCompleta(m.id)}>
                              <Delete />
                            </IconButton>
                          }
                        >
                          <ListItemText primary={`Mesa #${m.code}`} secondary={`Capacidade: ${m.capacidade || 4} pessoas | Status: ${m.status === 'close' ? 'Ocupada' : 'Livre'}`} />
                        </ListItem>
                        <Divider />
                      </React.Fragment>
                    ))}
                  </List>
                </Paper>
              </Grid>



            </Grid>
          )
        }

        {tabAtual == 4 && (<><PrinterSettings /></>)}






        <Dialog
          open={Object.keys(this.state.openTable).length > 0}
          onClose={() => !loading && this.setState({ openTable: {} })}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Abrir mesa {this.state.openTable.code}
            </Typography>
            <IconButton
              onClick={() => this.setState({ openTable: {} })}
              disabled={loading}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            <Grid container spacing={2} sx={{ mt: 0.5 }}>
              {/* 1. Quantidade de Pessoas */}
              <Grid item size={{ xs: 12, sm: 6 }} >
                <TextField
                  label="Qtd. de Pessoas"
                  type="number"
                  fullWidth
                  autoComplete='off'
                  size="small"
                  inputProps={{ min: 1 }}
                  value={this.state.openTable.persons || 1}
                  onChange={(e) => {
                    const value = e.target.value;
                    this.setState((prevState) => ({
                      openTable: {
                        ...prevState.openTable,
                        persons: value
                      }
                    }));
                  }}
                  disabled={loading}
                />
              </Grid>

              {/* 2. Identificação da Mesa */}
              <Grid item size={{ xs: 12, sm: 6 }} >
                <TextField
                  label="Identificação Da Mesa"
                  placeholder="(opcional)"
                  fullWidth
                  autoComplete='off'
                  size="small"
                  value={this.state.tableIdentification || ''}
                  onChange={(e) => this.setState({ tableIdentification: e.target.value })}
                  disabled={loading}
                />
              </Grid>

              {/* 3. Atendente Responsável */}

            </Grid>
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item size={{ xs: 12, sm: 6 }} >

              </Grid>
              <Grid item size={{ xs: 12, sm: 12 }} >
                <Autocomplete
                  options={this.state.customersList || []}
                  getOptionLabel={(option) =>
                    typeof option === 'string'
                      ? option
                      : `${option.name || ''} ${option.phone ? `(${option.phone})` : ''}`
                  }
                  filterOptions={(x) => x}
                  // Encontra o objeto do cliente na lista com base no ID salvo em state.openTable.client
                  value={
                    (this.state.customersList || []).find(
                      (c) => c.id === this.state.openTable?.client
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  onChange={(event, newValue) => {
                    this.setState((prevState) => ({
                      openTable: {
                        ...prevState.openTable,
                        client: newValue ? newValue.id : null // Trata se newValue for null ao limpar
                      }
                    }));
                  }}
                  onInputChange={(event, newInputValue) => {
                    this.handleSearchCustomers(newInputValue);
                  }}
                  disabled={loading}
                  noOptionsText="Nenhum cliente encontrado"
                  loadingText="Buscando clientes..."
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Buscar e Associar Cliente"
                      placeholder="Digite o nome ou telefone..."
                      size="small"
                      autoComplete="off"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {this.state.loadingCustomers ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button
              onClick={() => this.setState({ openTable: {} })}
              disabled={loading}
              color="inherit"
            >
              Cancelar
            </Button>
            <Button
              onClick={() => {
                const mesa = this.state.openTable;

                fetch(`${apiUrl}/tables/${mesa.id}/open`, {
                  method: "POST",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ persons: mesa.persons, client: mesa.client }),
                })
                  .then((response) => {
                    if (response.ok) {
                      this.setState(prevState => ({
                        mesas: prevState.mesas.map(m =>
                          m.id === mesa.id ? { ...m, status: 1, total: 0, itens: [] } : m
                        ),
                        openTable: {}
                      }));
                    }
                  })
                  .catch((error) => {
                    console.error("Erro na requisição:", error);
                  });
              }}
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {loading ? "Abrindo..." : "Confirmar Abertura"}
            </Button>
          </DialogActions>
        </Dialog>




        {/* MODAL 1: EXTRATO DA COMANDA */}
        <Dialog
          open={modalComandaAberto}
          onClose={() => !loading && this.setState({ modalComandaAberto: false })}
          maxWidth="sm"
          fullWidth
        >
          {/* Cabeçalho Limpo e de Alta Visibilidade */}
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
            <Box>
              <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                Mesa #{mesaSelecionada?.code}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {itensTable.length} {itensTable.length === 1 ? 'item lançado' : 'itens lançados'}
              </Typography>
            </Box>
            <Chip
              label={`Total: ${Number(mesaSelecionada?.total || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`}
              color="primary"
              sx={{ fontSize: '1rem', fontWeight: 'bold', py: 2 }}
            />
          </DialogTitle>

          <DialogContent dividers sx={{ p: 0 }}>
            <List sx={{ maxHeight: 350, overflow: 'auto' }}>
              {itensTable.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{ p: 3, textAlign: 'center' }}>
                  Nenhum item adicionado a esta mesa.
                </Typography>
              ) : (
                itensTable.map((item, index) => (
                  <React.Fragment key={index}>
                    <ListItem
                      secondaryAction={
                        <IconButton
                          edge="end"
                          aria-label="remover"
                          color="error"
                          disabled={loading}
                          onClick={() => {
                            this.setState({ modalSenhaAberto: true })
                          }} // Crie esta função na sua classe
                          sx={{ ml: 1 }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      }
                      sx={{ py: 1.5 }}
                    >
                      <ListItemText
                        primary={<Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{item.produto_name}</Typography>}
                        secondary={
                          <Typography variant="caption" color="text.secondary">
                            {item.quantidade}x ({Number(item.valor_venda).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} un)
                          </Typography>
                        }
                      />
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mr: 2 }}>
                        {(item.valor_venda * item.quantidade).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                      </Typography>
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                ))
              )}
            </List>
          </DialogContent>

          {/* Ações do Garçom */}
          <DialogActions sx={{ justifyContent: 'space-between', p: 2 }}>
            <Button
              onClick={() => this.setState({ modalComandaAberto: false })}
              color="inherit"
              disabled={loading}
            >
              Fechar
            </Button>

            <Box sx={{ display: 'flex', gap: 1 }}>
              {/* Botão Principal do Garçom: Lançar mais produtos */}
              <Button
                variant="contained"
                color="success"
                startIcon={<AddShoppingCartIcon />}
                disabled={loading}
                onClick={() => {
                  fetch(`${apiUrl}/store/menu`, {
                    method: "GET",
                    credentials: "include",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + localStorage.getItem("userToken"),
                    },
                  }).then((response) => {
                    response.json().then((data) => {
                      this.setState({ modalComandaAberto: false, dadosCategorias: data, dialogAberto: true });
                    });
                  })
                }}
              >
                Lançar Itens
              </Button>

              {/* Botão do Caixa */}
              <Button
                variant="contained"
                color="warning"
                startIcon={<PointOfSale />}
                disabled={loading || itensTable.length === 0}
                onClick={() => {
                  this.setState({ modalComandaAberto: false });
                  this.handleIniciarFinalizacao(mesaSelecionada);
                }}
              >
                Ir para o Caixa
              </Button>
            </Box>
          </DialogActions>
        </Dialog>

        <Dialog
          open={Object.keys(this.state.cancelar || {}).length > 0}
          onClose={() => {
            if (!loading) this.setState({ cancelar: {} });
          }}
          maxWidth="sm"
          fullWidth
        >
          {/* Cabeçalho de Alerta */}
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
            <Box>
              <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', color: 'error.main' }}>
                Cancelar Mesa #{this.state.cancelar?.code}?
              </Typography>

              <Typography variant="caption" color="text.secondary">
                Esta ação é irreversível
              </Typography>
            </Box>
            <Chip
              label={`Total: ${Number(this.state.cancelar?.total || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`}
              color="error"
              variant="outlined"
              sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}
            />
          </DialogTitle>

          <DialogContent dividers sx={{ p: 0 }}>
            {/* Aviso claro para o operador */}
            <Alert severity="warning" sx={{ borderRadius: 0, py: 1 }}>
              Você está prestes a cancelar todos os itens da comanda abaixo.
            </Alert>


          </DialogContent>

          <DialogActions sx={{ justifyContent: 'space-between', p: 2 }}>
            {/* Corrigido: Agora fecha o modal zerando o estado 'cancelar' */}
            <Button
              onClick={() => this.setState({ cancelar: {} })}
              color="inherit"
              disabled={loading}
            >
              Voltar / Manter Mesa
            </Button>

            <Button
              variant="contained"
              color="error"
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CancelIcon />}
              disabled={loading}
              onClick={() => {
                this.setState({ loading: true });

                fetch(`${apiUrl}/tables/${this.state.cancelar.id}/cancel`, {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer " + localStorage.getItem("userToken"), // Boa prática incluir caso a rota exija
                  }
                })
                  .then(response => {
                    if (response.status === 200) {
                      this.setState((prevState) => ({
                        mesas: prevState.mesas.map((mesa) => {
                          if (mesa.id === this.state.cancelar.id) {
                            return { ...mesa, status: 0, itens: [], total: 0 };
                          }
                          return mesa;
                        }),
                        mesaSelecionada: null,
                        cancelar: {},
                        loading: false,
                      }));
                    } else {
                      alert("Não foi possível cancelar os itens desta mesa.");
                      this.setState({ loading: false });
                    }
                  })
                  .catch(err => {
                    console.error(err);
                    this.setState({ loading: false });
                  });
              }}
            >
              {loading ? "Cancelando..." : "Confirmar Cancelamento"}
            </Button>
          </DialogActions>
        </Dialog>



        {/* MODAL 2: FLUXO DE PAGAMENTO DIVIDIDO / MÚLTIPLO */}
        <Dialog
          open={modalPagamentoAberto}
          onClose={() => !loading && this.setState({ modalPagamentoAberto: false })}
          maxWidth="xl"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 'bold', textAlign: 'center', bg: 'grey.100', py: 1.5 }}>
            Fechamento da Mesa #{mesaSelecionada?.code}
          </DialogTitle>

          <DialogContent dividers sx={{ p: { xs: 2, md: 3 } }}>
            <Grid container spacing={3}>

              {/* PAINEL ESQUERDO: Ações e Valores */}
              <Grid item size={{ xs: 12, md: 6 }}>

                {/* Card de Resumo Financeiro */}
                <Paper
                  elevation={0}
                  sx={{ p: 2, mb: 2, borderRadius: 2, border: '1px solid', borderColor: 'divider', bgcolor: '#f8f9fa' }}
                >
                  <Grid container spacing={1} sx={{ justifyContent: 'space-between' }} >
                    <Grid item>
                      <Typography variant="caption" color="text.secondary">Total da Mesa</Typography>
                      <Typography variant="h6" fontWeight="bold">
                        {totalMesa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                      </Typography>
                    </Grid>

                    <Grid item>
                      <Typography variant="caption" color="text.secondary">Total Pago</Typography>
                      <Typography variant="h6" fontWeight="bold" color="success.main">
                        {totalPagoAteAgora.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 1.5 }} />

                  {/* Destaque para Saldo Restante / Troco */}
                  <Box sx={{ textAlign: 'center', py: 0.5 }}>
                    {saldoRestante > 0 ? (
                      <Box sx={{ bgcolor: 'error.50', p: 1, borderRadius: 1.5, border: '1px solid', borderColor: 'error.light' }}>
                        <Typography variant="caption" color="error.dark" fontWeight="bold">RESTANTE A PAGAR</Typography>
                        <Typography variant="h4" fontWeight="800" color="error.main">
                          {saldoRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </Typography>
                      </Box>
                    ) : (
                      <Box sx={{ bgcolor: 'success.50', p: 1, borderRadius: 1.5, border: '1px solid', borderColor: 'success.light' }}>
                        <Typography variant="caption" color="success.dark" fontWeight="bold">TROCO A DEVOLVER</Typography>
                        <Typography variant="h4" fontWeight="800" color="success.main">
                          {trocoCalculado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Paper>

                {/* Seleção do Método de Pagamento */}
                <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
                  1. Selecione a Forma de Pagamento
                </Typography>
                <ToggleButtonGroup
                  value={metodoPagamentoAtual}
                  exclusive
                  onChange={this.handleMetodoPagamentoChange}
                  fullWidth
                  size="medium"
                  sx={{ mb: 2, '& .MuiToggleButton-root': { py: 1.5, fontWeight: 'bold' } }}
                >
                  <ToggleButton value="money" color="success">
                    <AttachMoney sx={{ mr: 0.5 }} /> Dinheiro
                  </ToggleButton>
                  <ToggleButton value="qr" color="primary">
                    <QrCodeIcon sx={{ mr: 0.5 }} /> PIX
                  </ToggleButton>
                  <ToggleButton value="credit_card" color="secondary">
                    <CreditCardIcon sx={{ mr: 0.5 }} /> Crédito
                  </ToggleButton>
                  <ToggleButton value="debit_card" color="secondary">
                    <CreditCardIcon sx={{ mr: 0.5 }} /> Débito
                  </ToggleButton>
                  <ToggleButton value="voucher" color="secondary">
                    <CreditCardIcon sx={{ mr: 0.5 }} /> Voucher
                  </ToggleButton>
                </ToggleButtonGroup>

                {/* Input de Valor Mapeado em BRL */}
                <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
                  2. Informe o Valor
                </Typography>

                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="R$ 0,00"
                  // Transforma o número do state em R$ 0,00 para exibição
                  value={
                    this.state.valorInseridoAtual || this.state.valorInseridoAtual === 0
                      ? Number(this.state.valorInseridoAtual).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })
                      : ''
                  }
                  onChange={(e) => {
                    // 1. Extrai apenas os dígitos digitados
                    const apenasDigitos = e.target.value.replace(/\D/g, '');

                    // 2. Transforma em número decimal (divide por 100 para contar centavos)
                    const valorNumerico = apenasDigitos ? parseFloat(apenasDigitos) / 100 : 0;

                    // 3. Salva no state estritamente como NUMBER
                    this.setState({ valorInseridoAtual: valorNumerico });
                  }}
                  inputProps={{
                    style: { fontSize: '1.25rem', fontWeight: 'bold' },
                    inputMode: 'numeric' // Abre o teclado numérico em celulares/tablets
                  }}
                  sx={{ mb: 1.5 }}
                />

                {/* Atalhos Rápidos (Fast-Cash) */}
                <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                  <Button size="small" variant="outlined" onClick={() => this.setState({ valorInseridoAtual: 2 })}>
                    + R$ 2
                  </Button>
                  <Button size="small" variant="outlined" onClick={() => this.setState({ valorInseridoAtual: 5 })}>
                    + R$ 5
                  </Button>
                  <Button size="small" variant="outlined" onClick={() => this.setState({ valorInseridoAtual: 10 })}>
                    + R$ 10
                  </Button>
                  <Button size="small" variant="outlined" onClick={() => this.setState({ valorInseridoAtual: 20 })}>
                    + R$ 20
                  </Button>
                  <Button size="small" variant="outlined" onClick={() => this.setState({ valorInseridoAtual: 50 })}>
                    + R$ 50
                  </Button>
                </Stack>

                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={this.handleAdicionarPagamento}
                  disabled={!valorInseridoAtual || valorInseridoAtual === 0}
                  sx={{ py: 1.2, fontWeight: 'bold' }}
                >
                  Adicionar Pagamento
                </Button>
              </Grid>

              {/* PAINEL DIREITO: Extrato dos Pagamentos Lançados */}
              <Grid item size={{ xs: 12, md: 6 }}>


                <Paper
                  variant="outlined"
                  sx={{
                    minHeight: 280,
                    maxHeight: 380,
                    overflow: 'auto',
                    p: 1,
                    bgcolor: '#fafafa',
                    borderRadius: 2
                  }}
                >
                  {pagamentosLancados.length === 0 ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 240, opacity: 0.6 }}>
                      <AttachMoney fontSize="large" color="disabled" />
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Nenhum pagamento adicionado
                      </Typography>
                    </Box>
                  ) : (
                    <List dense>
                      {pagamentosLancados.map((p, idx) => (
                        <Paper key={idx} elevation={0} sx={{ mb: 1, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                          <ListItem
                            secondaryAction={
                              <IconButton
                                edge="end"
                                size="small"
                                color="error"
                                disabled={loading}
                                onClick={() => this.handleRemoverPagamentoLancado(idx)}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            }
                          >
                            <ListItemText
                              primary={
                                <Typography variant="subtitle2" fontWeight="bold">
                                  {p.metodo.toUpperCase()}
                                </Typography>
                              }
                              secondary={
                                <Typography variant="body2" color="success.main" fontWeight="bold">
                                  {p.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                </Typography>
                              }
                            />
                          </ListItem>
                        </Paper>
                      ))}
                    </List>
                  )}
                </Paper>
              </Grid>

            </Grid>
          </DialogContent>

          {/* AÇÕES FINAIS */}
          <DialogActions sx={{ p: 2, bgcolor: 'grey.50' }}>
            <Button
              onClick={() => this.setState({ modalPagamentoAberto: false })}
              color="inherit"
              disabled={loading}
              sx={{ px: 3 }}
            >
              Voltar
            </Button>
            <Button
              onClick={this.handleFinalizarEFecharMesa}
              color="success"
              variant="contained"
              disabled={totalPagoAteAgora < totalMesa || loading}
              size="large"
              sx={{ px: 4, py: 1.2, fontWeight: 'bold' }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Confirmar e Liberar Mesa'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* MODAL 3: TROCAR DE MESA */}
        <Dialog open={modalTrocarMesaAberto} onClose={() => !loading && this.setState({ modalTrocarMesaAberto: false })} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ fontWeight: 'bold' }}>Trocar Mesa #{mesaSelecionada?.code}</DialogTitle>
          <DialogContent dividers>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Selecione para qual mesa livre você deseja transferir todo o consumo atual deste cliente.
            </Typography>
            <FormControl fullWidth size="small">
              <InputLabel>Mesa de Destino</InputLabel>
              <Select
                value={mesaDestinoId}
                label="Mesa de Destino"
                disabled={loading}
                onChange={(e) => this.setState({ mesaDestinoId: e.target.value })}
              >
                {mesas.filter(m => m.status === 'open').map(m => (
                  <MenuItem key={m.id} value={m.id}>Mesa #{m.code} (Cap: {m.capacidade || 4})</MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ modalTrocarMesaAberto: false })} color="inherit" disabled={loading}>Cancelar</Button>
            <Button
              onClick={this.handleTrocarMesa}
              color="primary"
              variant="contained"
              disabled={loading}
            >
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Confirmar Mudança'}
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog
          open={this.state.modalSenhaAberto}
          onClose={() => !loading && this.setState({ modalSenhaAberto: false, senhaSupervisor: '', erroSenha: '' })}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
            <LockIcon color="warning" /> Autorização Requerida
          </DialogTitle>

          <DialogContent dividers>
            <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
              Informe a senha do supervisor/gerente para confirmar esta ação.
            </Typography>

            <TextField
              autoFocus
              fullWidth
              type="password"
              label="Senha do Supervisor"
              variant="outlined"
              value={this.state.senhaSupervisor || ''}
              onChange={(e) => this.setState({ senhaSupervisor: e.target.value, erroSenha: '' })}
              error={Boolean(this.state.erroSenha)}
              helperText={this.state.erroSenha}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  this.handleValidarSenhaEConfirmar();
                }
              }}
            />
          </DialogContent>

          <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
            <Button
              onClick={() => this.setState({ modalSenhaAberto: false, senhaSupervisor: '', erroSenha: '' })}
              color="inherit"
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={loading || !this.state.senhaSupervisor}
              onClick={() => this.handleValidarSenhaEConfirmar()}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Confirmar"}
            </Button>
          </DialogActions>
        </Dialog>

        <FrenteDeCaixaDialog
          open={this.state.dialogAberto}
          onClose={() => this.setState({ dialogAberto: false })}
          dadosCategorias={this.state.dadosCategorias}
          onFinalizarVenda={(itens, total) => {


            fetch(`${process.env.REACT_APP_API_URL}/store/open/command`, {
              method: 'POST',
              credentials: 'include',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ mesaId: this.state.mesaSelecionada.id, itens }),
            })
              .then(response => {
                if (response.status == 200) {
                  console.log('mesa:')
                  console.log(this.state.mesaSelecionada)
                  this.setState((prevState) => ({

                    dialogAberto: false,
                  }));


                  if (localStorage.getItem("printer_settings") == null) {
                    return false
                  }

                  const printSettings = JSON.parse(localStorage.getItem("printer_settings"));

                  if (["cozinha", "balcao"].includes(printSettings.printLocation)) {
                    return false;
                  }


                  if (printSettings != null) {

                    if (printSettings.connectionType == "ip") {
                      this.printWithAgent(this.state.mesaSelecionada.code, itens, printSettings.ipAddress);
                    } else if (printSettings.connectionType == "usb") {
                      this.printWithAgent(this.state.mesaSelecionada.code, itens);
                    } else {
                      this.printWithBrowser(this.state.mesaSelecionada.code, itens);

                    }

                  } else {
                    this.printWithBrowser(this.state.mesaSelecionada.code, itens);
                  }



                }
              })
          }}
        />
      </Box >
    );
  }
}
const tagStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.8,
  border: '1px solid #e0e0e0',
  borderRadius: 1.5,
  px: 1,
  py: 0.5,
  flex: 1,
  bgcolor: '#fff',
};

const textTagStyle = {
  fontSize: '0.75rem',
  color: '#555',
  fontWeight: 500,
};
export default SistemaMesas;